<div class="d-flex flex-column">
    <button (click)="openModal()" class="btn btn-primary">
        <span *ngIf="isReadonly()">
            {{'assignments.participants.attendances.openDisplayModal' | transloco}}
        </span>
        <span *ngIf="!isReadonly()">
            {{'assignments.participants.attendances.openEditModal' | transloco}}
        </span>
    </button>
</div>